//import Vue from 'vue';
//import Router from 'vue-router';

Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/index'
},
{
    path: '/',
    name: '首页',
    component: resolve=>(require(["./view/layout"],resolve)),
    children: [{
        name: '首页',
        path: 'index',
        component: resolve=>(require(["./view/index"],resolve)),

    }, {
        name: '个人设置',
        path: 'setting',
        component: resolve=>(require(["./view/setting"],resolve)),

    }, {
        name: '资源库上传',
        path: 'upload',
        component: resolve=>(require(["./view/upload"],resolve)),

    },
    {
        name: '文章页',
        path: 'article',
        component: resolve=>(require(["./view/article"],resolve)),
    },
    {
        name: '项目填写',
        path: 'submitted', 
        component: resolve=>(require(["./view/submitted"],resolve)),
    },
    {
        name: '选课',
        path: 'xuanke',
        component: resolve=>(require(["./view/xuanke"],resolve)),
    },
    {
        name: '帮助中心',
        path: 'help',
        component: resolve=>(require(["./view/help"],resolve)),
    },
    {
        name: '应用介绍',
        path: 'introduction',
        component: resolve=>(require(["./view/introduction"],resolve)),
    },
    {
        name: '设置中心',
        path: 'setCenter',
        component: resolve=>(require(["./view/setCenter"],resolve)),
    },
    {
        name: '申请调课',
        path: 'adjust',
        component: resolve=>(require(["./view/adjust"],resolve)),
    },
    {
        name: '选择上传方式',
        path: 'gardeType',
        component: resolve=>(require(["./view/grade/gardeType"],resolve)),
    },
    {
        name: '上传成绩单',
        path: 'uploadGrade',
        component: resolve=>(require(["./view/grade/uploadGrade"],resolve)),
    },
    {
        name: '成绩单',
        path: 'gradeDetil',
        component: resolve=>(require(["./view/grade/gradeDetil"],resolve)),
    },
    {   
        name: '修改成绩单',
        path: 'gradeModif',
        component: resolve=>(require(["./view/grade/gradeModif"],resolve)),
    },
    {   
        name: '成绩单',
        path: 'gradeNoDetil',
        component: resolve=>(require(["./view/grade/gradeNoDetil"],resolve)),
    },
    {   
        name: '修改成绩单',
        path: 'gradeNoModif',
        component: resolve=>(require(["./view/grade/gradeNoModif"],resolve)),
    },
    ]
},
{
    path:'/verifyAccount',
    name: '/verifyAccount',
    component: resolve=>(require(["./view/verifyAccount"],resolve)),
    meta: {
        title: '忘记密码'
    },
}

];



// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

const router = new VueRouter({ routes });

router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;

    if (title) {
        document.title = title;
    }
    next()

});

export {
    router
};